export type MonitoringRoutes =
  | 'Feature View Monitoring'
  | 'SLO Monitoring'
  | 'Feature Server Monitoring'
  | 'Stream Ingest Monitoring';

export type MonitoringFeatureServiceRoutes = 'Feature View' | 'Server Groups' | 'Stream Ingest';

export const getMonitoringFeatureServiceGroupRoutes = (): Record<MonitoringFeatureServiceRoutes, string> => {
  return {
    'Feature View': 'feature-view-monitoring',
    'Server Groups': 'realtime-server',
    'Stream Ingest': 'stream-ingest',
  };
};

export const getMonitoringRouteName = (pathname: string): MonitoringRoutes | MonitoringFeatureServiceRoutes => {
  const pathSegments = pathname.split('/');
  const lastPathSegment = pathSegments[pathSegments.length - 1];
  const routes = getMonitoringFeatureServiceGroupRoutes();
  const record = Object?.entries(routes)?.find((record) => {
    return record[1] === lastPathSegment;
  });

  return (record?.[0] ?? 'Feature View Monitoring') as MonitoringRoutes;
};
